<template>
  <SfTable>
    <SfTableHeading>
      <SfTableHeader v-for="header in tableHeaders" :key="header">
        {{ header }}
      </SfTableHeader>
    </SfTableHeading>
    <SfTableRow v-for="(row, key) in products" :key="key">
      <SfTableData v-for="(data, index) in row" :key="index">
        {{ data }}
      </SfTableData>
    </SfTableRow>
  </SfTable>
</template>
<script>
import { SfTable } from '@storefront-ui/vue/';
import { config } from '@/modules/core';

import cart from '../../../mixins/cart';

export default {
  name: 'ProductsTable',
  mixins: [cart, config],
  components: {
    SfTable,
  },
  data() {
    return {
      tableHeaders: [
        this.$t('Name'),
        this.$t('Sku'),
        this.$t('Qty'),
        this.$t('Gross Price'),
        this.$t('Discount'),
        this.$t('Price without discount'),
        this.$t('Total Price'),
      ],
    };
  },
  computed: {
    products() {
      return this.cart.map((product) => [
        product.Product.Name,
        product.Product.Sku,
        product.Quantity,
        this.currencyFormatter().format(product.Product.Price),
        `${product.Product.Discount}%`,
        product.Product.OldPrice
          ? this.currencyFormatter().format(product.Product.OldPrice)
          : this.currencyFormatter().format(product.Product.Price),
        this.currencyFormatter().format(product.Total),
      ]);
    },
  },
};
</script>
